import moment from "moment";
import {MyCouponJson} from "../../model/coupons/MyCouponJson";
import React, {useEffect} from "react";
import {backgroundImage} from "html2canvas/dist/types/css/property-descriptors/background-image";

type Props = {
    data: MyCouponJson
};

type State = {
    checked?: boolean,
    loaded: boolean
};

class ComponentToPrint extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {loaded: false};
    }

    // onTrigger = (tourNm: string) => {
    //     console.log('onTrigger start');
    //     const that=this;
    //     if(this.state.loaded){
    //        this.props.parentCallback(tourNm);
    //
    //     }else {
    //         setTimeout(function () {
    //             that.onTrigger(tourNm);
    //         }, 1000);
    //     }
    //
    // }

    componentDidMount() {
        //this.onTrigger(this.props.data.name);
    }

    render() {
        const printId = 'print-area';
        const myCoupon = this.props.data;

        console.log(`myCoupon=${JSON.stringify(myCoupon)}`);
        const tourCert = myCoupon.tourCert;
        let userName = '', joinDate = '', issuedDate = '', img = '';
        if (tourCert) {
            userName = tourCert.name;
            img = tourCert.img;
            joinDate = `${moment(myCoupon.createDate).format('YYYY.MM.DD')} ~ ${moment(myCoupon.usedDate).format('MM.DD')}`;
            issuedDate = moment(tourCert.createDate).format('YYYY.MM.DD HH:mm:ss');
        }

        return (
            <div className="jb-wrap" id={printId}>
                <div className="jb-image">
                    <img src={img} alt=""
                         onLoad={() => this.setState({loaded: true})}/></div>
                <div className="jb-text">
                    <div className="jb-text-table">
                        <div className="jb-text-table-row">
                            <div className="jb-text-table-cell">
                                <p>인증자명: {userName}</p>
                                <p>참여기간: {joinDate}</p>
                                <p>발급일시: {issuedDate}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ComponentToPrint;
